module.exports = __webpack_public_path__ + "static/media/Feeling angry.f9f0c3f4.gif";